// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Yellowtail&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".only-closed,.only-open{transition:all .5s ease-in-out}.closed-sidebar:not(.closed-sidebar-open) .app-header__logo img{margin-left:-5px;width:250px}.closed-sidebar-open:not(.closed-sidebar) .app-header__logo img{width:180px}.app-header__logo img{margin-right:10px;width:180px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
